export default "__VITE_ASSET__bqFG_khq__"